import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconShield",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, _, f, a) {
  return r(), d("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--shield"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Shield",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.824.532a.5.5 0 0 1 .352 0l4 1.5a.5.5 0 0 1 .324.468V6c0 1.723-1.14 3.1-2.17 4.001a11.338 11.338 0 0 1-2.053 1.418l-.038.02-.01.006-.004.001S6.223 11.448 6 11l-.224.447h-.001l-.004-.002-.01-.006-.038-.02a10.362 10.362 0 0 1-.613-.355c-.39-.244-.914-.603-1.44-1.063C2.64 9.101 1.5 7.723 1.5 6V2.5a.5.5 0 0 1 .324-.468l4-1.5ZM6 11l-.224.447c.14.07.308.07.448 0L6 11Zm0-.569a10.341 10.341 0 0 0 1.67-1.183C8.64 8.4 9.5 7.278 9.5 6V2.846L6 1.534 2.5 2.846V6c0 1.277.86 2.4 1.83 3.249A10.341 10.341 0 0 0 6 10.43Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=shield.js.map
